export const phoneRule = {
  getMessage: (field) => `The ${field} field is not a valid phone number`,
  validate: (value, args) => {
    // We add this here. Empty phone numbers default to 'No Phone' in the API
    // per Jerrys request
    if (value === 'No Phone') {
      return true;
    }
    value = value.trim();

    if (args && args[0]) {
      value = args[0] + value;
    }

    // if value contains letters then return false
    if (/[a-zA-Z]/.test(value)) {
      return false;
    }
    // if value contains anything other than numbers, spaces, dashes, and + then return false
    if (!/^[0-9\s-+()]+$/.test(value)) {
      return false;
    }

    let maxLength = 0;

    // old entries in db allowed () around the number after the area code
    // cases are (123) 456-7890, +1 (123) 456-7890, +123 (123) 456-7890
    let openingBracketIndices = [...value.matchAll(new RegExp('\\(', 'gi'))].map((bracket) => bracket.index);
    let closingBracketIndices = [...value.matchAll(new RegExp('\\)', 'gi'))].map((bracket) => bracket.index);
    if (closingBracketIndices.length > 0 && openingBracketIndices.length === 0) {
      return false;
    }
    if (openingBracketIndices.length > 1 || closingBracketIndices.length > 1) {
      return false;
    }

    if (value.startsWith('+')) {
      if (!/^[0-9]+$/.test(value[1])) {
        return false;
      }

      // opening bracket test is performed at test above
      if (openingBracketIndices.length > 0 && closingBracketIndices.length > 0) {
        // BRACKETS CANNOT BE ON THE country CODE
        if (openingBracketIndices.includes(1) || closingBracketIndices.includes(1)) {
          console.log('fail 1');
          return false;
        }
        let splitOnSpaceAndDash = value.split(/[\s-]/);
        // if (splitOnSpaceAndDash[0].length - 1 === closingBracketIndices[0]) {
        //   console.log('fail 2');

        //   return false;
        // }

        if (openingBracketIndices[0] > (splitOnSpaceAndDash[0] + splitOnSpaceAndDash[1]).length - 1) {
          console.log('fail 3');

          return false;
        }
      }

      // not +1
      if ((value[1] != '1' && value[2] != ' ') || (args[0] && args[0] != '+1')) {
        maxLength = 15;
      } else {
        // allow the digit 1 from the area code in the count
        maxLength = 11;
      }
    } else {
      // default to us phone number
      // no area code so length 10
      maxLength = 10;
    }
    let phoneNumber = value.replace(/\D/g, '');
    if (phoneNumber.length > maxLength) {
      return false;
    } else {
      return true;
    }
  },
};
